import { MainTemplate } from 'Components/Template/MainTemplate'
import { makeAutoObservable } from 'mobx'

class StoreElement {
    cardTitle = {
        titleStep1: '',
        titleStep2: '',
        titleStep3: '',
        titleStep4: ''
    }

    settingCard = {
        title: '',
        titleAlign: '',
        padding: '',
        background: '',
        opacity: ''
    }

    userLayout = {
        className: ''
    }

    ResetCardTitle() {
        this.cardTitle = {
            titleStep1: '',
            titleStep2: ''
        }
    }
    ResetSettingCard() {
        this.settingCard = {
            title: '',
            titleAlign: '',
            padding: ''
        }
    }

    theme = MainTemplate

    constructor() {
        makeAutoObservable(this)
    }
}

export const storeElement = new StoreElement()
